import React from 'react';
import { AreasTable } from '../components/areas/AreasTable';

export default function Areas() {
	return <AreasTable />;
}
